import { render, staticRenderFns } from "./TeGlobalFooter.vue?vue&type=template&id=44e9e520&"
import script from "./TeGlobalFooter.vue?vue&type=script&lang=ts&"
export * from "./TeGlobalFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports